import { ContextMenuPanel } from "./ContextMenuPanel";
import { useContextMenu } from "./useContextMenu";

import type { ContextMenuItem } from "./ContextMenuPanel";
import type { VirtualElement } from "@floating-ui/react";
import type { MouseEvent, ReactNode } from "react";

export function MousePositionContextMenu({
  items,
  children,
  onOpenChange,
  getReference,
}: {
  items: ContextMenuItem[];
  children: ReactNode;
  onOpenChange?: (open: boolean) => void;
  getReference?: (event: MouseEvent) => Element | VirtualElement;
}) {
  const menu = useContextMenu({ onOpenChange });

  const handleContextMenu = (event: MouseEvent) => {
    if (items.length === 0) {
      return;
    }

    event.preventDefault();

    if (getReference) {
      menu.openAtReference(getReference(event));
    } else {
      menu.openAtPoint(event.clientX, event.clientY);
    }
  };

  return (
    <div
      className="contents"
      ref={menu.refs.setReference}
      {...menu.getReferenceProps({ onContextMenu: handleContextMenu })}
    >
      {children}
      <ContextMenuPanel menu={menu} items={items} />
    </div>
  );
}
